import type FileInput from "@components/Atoms/FileInput/FileInputProps";
import type ApiUrlCreator from "@core-ui/ApiServices/ApiUrlCreator";
import type { Router } from "@core/Api/Router";
import type Link from "../../core/components/Atoms/Link";
import type FetchService from "../../core/ui-logic/ApiServices/FetchService";

interface DynamicModules {
	Link: typeof Link;
	Router: typeof BrowserRouter | typeof NextRouter;
	Fetcher: typeof FetchService.fetch;
	useImage: typeof useUrlImage;
	FileInput: FileInput;
	openDirectory: () => string | Promise<string>;
	enterpriseLogin: (url: string, apiUrlCreator: ApiUrlCreator, router: Router) => Promise<void>;
	openChildWindow: ({
		url,
		redirect,
		name,
		features,
	}: {
		url: string;
		redirect?: string;
		name?: string;
		features?: string;
	}) => Promise<Window> | Window;
	httpFetch: typeof httpFetch;
}

let modules: DynamicModules;

/////////////////////////////////////
////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////

///////////
///////////////////
///////////////////////
//////////////////////////////
/////////////////////////////
////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////
/////////////////////////
/////////////////////////////////
////////////////////////////
//

//////////
// #v-endif

//////////////////////////////////
// #v-ifdef VITE_ENVIRONMENT=next
import FileInputCdn from "@components/Atoms/FileInput/FileInputCdn";
import LanguageService from "@core-ui/ContextServices/Language";
import Localizer from "@ext/localization/core/Localizer";
import NextLink from "../../apps/next/components/Atoms/Link";
import NextRouter from "../../apps/next/logic/Api/NextRouter";
import useUrlImage from "../../core/components/Atoms/Image/useUrlImage";
import Method from "../../core/ui-logic/ApiServices/Types/Method";
import MimeTypes from "../../core/ui-logic/ApiServices/Types/MimeTypes";
import Url from "../../core/ui-logic/ApiServices/Types/Url";

modules = {
	Link: NextLink,
	Router: NextRouter,
	Fetcher: async <T = any>(url: Url, body?: BodyInit, mime?: MimeTypes, method?: Method) => {
		const l = Localizer.extract(window.location.pathname);

		const res = (await fetch(
			url.toString(),
			body
				? {
						method,
						body,
						headers: {
							"Content-type": mime,
							"x-gramax-ui-language": LanguageService.currentUi(),
							"x-gramax-language": l,
						},
				  }
				: { headers: { "x-gramax-ui-language": LanguageService.currentUi(), "x-gramax-language": l } },
		)) as FetchResponse<T>;
		res.buffer = async () => Buffer.from(await res.arrayBuffer());
		return res;
	},

	useImage: useUrlImage,
	enterpriseLogin: () => null,
	openChildWindow: (params) =>
		typeof window === "undefined" ? undefined : window.open(params.url, params.name, params.features),
	openDirectory: () => "",
	FileInput: FileInputCdn,
	httpFetch: () => undefined,
};

// #v-endif
//////////
// #v-endif

//////////////////////////////////
/////////////////////////////////
////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////

///////////
////////////////////
////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////
/////////////////////////////
/////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////
/////////////////////////////
////////////////////////////
//

///////////
//////////

///////////////////////////////////
//////////////////////////////////
///////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////

///////////
/////////////////
/////////////////////
//////////////////////////////
///////////////////////
/////////////////
/////////////////
///////////////////////////////
///////////////
///////////
//

///////////
//////////

const resolveModule = <K extends keyof DynamicModules>(name: K): DynamicModules[K] => {
	const module = modules[name];
	if (!module) throw new Error("Module " + name + " not found");
	return module;
};

export default resolveModule;
